import { createContext, useContext } from 'react';

// Define the app type interface
export enum AppType {
  ENTERPRISE = 'enterprise',
  AGENT = 'agent',
  ACCOUNTANT = 'accountant',
  ADMIN = 'admin',
  ANALYTICS = 'analytics',
  SALESTEAMDASHBOARD = 'sales-team-dashboard',
  EXEMPTION_PORTAL = 'exemption-portal',
}

// extend this to have baseURL, development environment, etc.
interface AppContextType {
  appType: AppType;
}

// Create the context using createContext
export const AppContext = createContext<AppContextType | undefined>(undefined);

// Create the useApp hook to consume the context
export const useApp = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used inside AppProvider');
  }
  return context;
};
